import { render, staticRenderFns } from "./FormNoteHistoryLog.vue?vue&type=template&id=0963e13b&scoped=true"
import script from "./FormNoteHistoryLog.vue?vue&type=script&lang=ts"
export * from "./FormNoteHistoryLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963e13b",
  null
  
)

export default component.exports